import React, { useRef, useLayoutEffect } from "react";

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  value: string;
};

/**
 * A textarea that grows with its content up to the CSS max-height, then scrolls
 * — no resize handle, no dead space when the text is short (same behaviour as
 * the chat composer). Pass min-h / max-h via className to bound it.
 */
const AutoGrowTextarea: React.FC<Props> = ({ value, style, ...rest }) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  return (
    <textarea
      ref={ref}
      value={value}
      rows={1}
      // Wrap long unbreakable strings (like the chat composer) so the text fills
      // the box instead of overflowing on one line and leaving empty space.
      style={{ lineBreak: "anywhere", overflowWrap: "anywhere", ...style }}
      {...rest}
    />
  );
};

export default AutoGrowTextarea;
